"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _qs = _interopRequireDefault(require("qs"));
var _ = require("..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var CustomLogin = /** @class */function (_super) {
  __extends(CustomLogin, _super);
  function CustomLogin(props) {
    var _this = _super.call(this, props) || this;
    _this.onChange = function (e) {
      var name = e.target.name;
      if (name === 'email') {
        _this.setState({
          email: e.target.value
        });
      } else if (name === 'password') {
        _this.setState({
          password: e.target.value
        });
      }
    };
    _this.onSubmit = function (e) {
      e.preventDefault();
      var _a = _this.state,
        email = _a.email,
        password = _a.password;
      // Validate entry
      if (email == null || email === '' || password == null || password === '') {
        _this.props.setError('Please fill in both email and password.');
        return;
      }
      _this.props.onLogin(email, password);
    };
    _this.state = {
      email: '',
      password: '',
      redirect: false,
      formError: false
    };
    return _this;
  }
  CustomLogin.prototype.componentDidMount = function () {
    var _a, _b;
    var email = (_b = _qs.default.parse((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search, {
      ignoreQueryPrefix: true
    })) === null || _b === void 0 ? void 0 : _b.email;
    if (email != null && typeof email === 'string') {
      this.setState({
        email: email
      });
    } else {
      this.setState({
        email: ''
      });
    }
  };
  CustomLogin.prototype.render = function () {
    if (this.props.redirect) return (0, _jsxRuntime.jsx)(_reactRouterDom.Redirect, {
      to: this.props.redirectLink
    });
    return (0, _jsxRuntime.jsx)(_material.Container, {
      children: (0, _jsxRuntime.jsxs)("form", __assign({
        autoComplete: "off",
        onSubmit: this.onSubmit,
        style: {
          marginBottom: '5em'
        }
      }, {
        children: [(0, _jsxRuntime.jsx)("div", __assign({
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '2em',
            marginBottom: '1em'
          }
        }, {
          children: this.props.logo != null && (0, _jsxRuntime.jsx)("img", {
            width: 250,
            src: this.props.logo,
            alt: 'Logo',
            title: 'Logo',
            style: {
              objectFit: 'contain'
            }
          })
        })), (0, _jsxRuntime.jsx)(_material.Typography, __assign({
          variant: "h1",
          style: {
            textAlign: 'center',
            marginBottom: '1em'
          }
        }, {
          children: "Login"
        })), (0, _jsxRuntime.jsx)(_material.TextField, {
          required: true,
          disabled: this.props.isLoading,
          error: this.state.formError && this.state.email === '',
          name: "email",
          label: "Email",
          type: "email",
          style: {
            width: '100%',
            marginBottom: '10px'
          },
          value: this.state.email,
          onChange: this.onChange,
          variant: "filled"
        }), (0, _jsxRuntime.jsx)(_material.TextField, {
          required: true,
          disabled: this.props.isLoading,
          error: this.state.formError && this.state.password === '',
          name: "password",
          label: "Password",
          style: {
            width: '100%',
            marginBottom: '10px'
          },
          value: this.state.password,
          onChange: this.onChange,
          variant: "filled",
          type: "password"
        }), (0, _jsxRuntime.jsxs)("div", __assign({
          style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '40px'
          }
        }, {
          children: [(0, _jsxRuntime.jsx)(_.Button, __assign({
            type: "submit",
            isLoading: this.props.isLoading,
            style: {
              width: '50%'
            }
          }, {
            children: "Login"
          })), (0, _jsxRuntime.jsxs)(_material.Typography, __assign({
            variant: "button",
            style: {
              marginTop: '10px'
            }
          }, {
            children: ["Need to make an account?", ' ', (0, _jsxRuntime.jsx)(_reactRouterDom.Link, __assign({
              to: this.props.createAccountLink,
              style: {
                color: this.props.color
              }
            }, {
              children: "Create one now"
            })), "."]
          })), (0, _jsxRuntime.jsxs)(_material.Typography, __assign({
            variant: "button",
            style: {
              marginTop: '10px'
            }
          }, {
            children: ["Forgot your password?", ' ', (0, _jsxRuntime.jsx)(_reactRouterDom.Link, __assign({
              to: this.props.resetPasswordLink,
              style: {
                color: this.props.color
              }
            }, {
              children: "Reset Now"
            })), "."]
          }))]
        }))]
      }))
    });
  };
  return CustomLogin;
}(_react.Component);
var _default = CustomLogin;
exports.default = _default;